import React from "react";
import { PublicRoutesProps } from "./type";

const PublicRoutes: React.FC<PublicRoutesProps> = ({ Component }) => {
  return (
    <>
      <Component />
    </>
  );
};

export default PublicRoutes;
